import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import { setRegistrationToken, setUserName } from '@/store/slices/auth/authSlice';
import { setRegistrationToken as persistRegistrationToken } from '@/utils/sessionStorage';
import type { BeginRegistrationDTO } from '@/types/DTOs';

export const verifyOtpThunk = createAppAsyncThunk<
  BeginRegistrationDTO,
  { username: string; otp: string }
>('auth/verifyOtp', async(params, { dispatch, extra: { authService }, rejectWithValue }) => {
  try {
    dispatch(setUserName(params.username));
    const result = await authService.beginRegistration(params);
    dispatch(setRegistrationToken(result.registrationToken));
    persistRegistrationToken(result.registrationToken);
    return result;
  } catch (error) {
    if (isAPIError(error) && error.fieldErrors != null) {
      // Correct: rejectWithValue with expected shape
      return rejectWithValue({ fieldErrors: error.fieldErrors });
    }
    throw error;
  }
});
